import { Button, Avatar, Badge } from "antd";
import { EditOutlined, EyeOutlined, UserOutlined } from "@ant-design/icons";
import DeleteUserConfirmation from "./user.delete.confirmation";
import UserDesignationCell from "./decorated.designation.cell";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

export const buildUserColumns = ({ onView, onEdit, onDelete, notify }) => [
  {
    title: "User",
    key: "name",
    fixed: "left",
    width: 260,
    render: (_, u) => (
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <Badge dot color={u.enabled ? "#52c41a" : "#f5222d"}>
          <Avatar icon={<UserOutlined />} />
        </Badge>
        <div>
          <div style={{ fontWeight: 500 }}>{u.firstName} {u.lastName}</div>
          <div style={{ fontSize: 12, color: "#888" }}>{u.email}</div>
        </div>
      </div>
    ),
  },
  {
    title: "Designation",
    dataIndex: "designation",
    render: (_, user) => <UserDesignationCell record={user} />,
    width: 180,
  },
  {
    title: "Joined",
    dataIndex: "createdDate",
    render: (date) => dayjs(date).format("MMM D, YYYY"),
    width: 130,
  },
  {
    title: "Last Login",
    dataIndex: "lastLoggedIn",
    render: (date) => (date ? dayjs(date).fromNow() : "Never"),
    width: 150,
  },
  {
    title: "Actions",
    key: "actions",
    fixed: "right",
    width: 120,
    render: (_, user) => (
      <div style={{ display: "flex", gap: 8 }}>
        <Button icon={<EyeOutlined />} onClick={() => onView(user)} />
        <Button icon={<EditOutlined />} onClick={() => onEdit(user)} />
        <DeleteUserConfirmation
          user={user}
          notifyApi={notify}
          onDeleteSuccess={() => onDelete(user.uid)}
        />
      </div>
    ),
  },
];
